import { FC } from "react";

const SettingsImportPage: FC = () => {
    return <>Manage import</>;
};

export default SettingsImportPage;
